import { Box, Typography } from "@mui/material";

export const RequiredBadge = () => {
  return (
    <Box
      bgcolor="#EA583B"
      color="white"
      width="28px"
      height="20px"
      borderRadius={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography fontSize="10px" fontWeight={700}>
        必須
      </Typography>
    </Box>
  );
};

export const CarrierSuggestionBadge = () => {
  return (
    <Box
      bgcolor="#3666E0"
      color="white"
      width="48px"
      height="16px"
      borderRadius={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography fontSize="10px" fontWeight={700}>
        車主提案
      </Typography>
    </Box>
  );
};
